import { render, staticRenderFns } from "./GaugeComparison.vue?vue&type=template&id=7ce0ecc4&scoped=true&"
import script from "./GaugeComparison.vue?vue&type=script&lang=ts&"
export * from "./GaugeComparison.vue?vue&type=script&lang=ts&"
import style0 from "./GaugeComparison.vue?vue&type=style&index=0&id=7ce0ecc4&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce0ecc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
